import React from 'react';
import { IndianRupee, X } from 'lucide-react';
import { formatInr as inr } from '../lib/formatInr';
import { GstSplitText } from './GstSplitText';

const Row = ({ label, value, testId, strong }) => (
  <div className={`flex justify-between gap-4 py-1.5 ${strong ? 'font-bold text-base' : ''}`}>
    <span>{label}</span>
    <span data-testid={testId}>{value}</span>
  </div>
);

export const EditPriceConfirmModal = ({ quote, busy, onCancel, onConfirm }) => {
  const b = quote.breakdown || {};
  const action = quote.payment_action;
  const headline = action === 'top_up'
    ? `Pay extra ${inr(quote.top_up_amount)}`
    : action === 'refund'
      ? `Refund of ${inr(quote.refund_amount)}`
      : 'No change in price';
  const note = action === 'top_up'
    ? 'Razorpay opens next to collect the extra amount. Pickup will go ahead once it is paid.'
    : action === 'refund'
      ? 'Your changes lower the price. Our team will refund the difference to your original payment method.'
      : 'Your changes do not affect the price.';

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="edit-price-modal">
      <div className="bg-white border-2 border-black w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b-2 border-black">
          <h3 className="font-black font-mono uppercase flex items-center gap-2"><IndianRupee size={16} />Updated price</h3>
          <button onClick={onCancel} data-testid="edit-price-close-btn" aria-label="Close"><X size={18} /></button>
        </div>
        <div className="p-4 font-mono text-sm">
          <Row label="Luggage charge" value={inr(b.luggage_charge)} testId="edit-price-luggage" />
          <Row label="GST" value={inr(b.gst_amount)} testId="edit-price-gst" />
          {Number(b.insurance_premium) > 0 && <Row label="Insurance" value={inr(b.insurance_premium)} testId="edit-price-insurance" />}
          <div className="border-t border-dashed border-gray-400 my-2" />
          <Row label="New total" value={inr(quote.new_amount)} testId="edit-price-new-total" strong />
          <Row label="Already paid" value={`− ${inr(quote.paid_so_far)}`} testId="edit-price-paid" />
          <div className={`mt-3 p-3 border-2 border-black ${action === 'top_up' ? 'bg-[#FFF7E6]' : action === 'refund' ? 'bg-green-50' : 'bg-gray-50'}`}>
            <div className="font-black text-lg" data-testid="edit-price-headline">{headline}</div>
            {action !== 'none' && <GstSplitText split={quote.difference_split} className="text-xs font-bold" testId="edit-price-split" />}
            <p className="text-xs mt-1 text-gray-700">{note}</p>
          </div>
          <p className="text-[11px] mt-3 text-gray-600 leading-snug" data-testid="edit-price-consent-text">
            By saving you agree to the Terms &amp; Conditions, Insurance and Refund policies, including your insurance choice for each bag.
          </p>
        </div>
        <div className="p-4 pt-0 flex gap-3">
          <button onClick={onCancel} data-testid="edit-price-cancel-btn" className="btn-secondary flex-1 py-2 text-sm">KEEP EDITING</button>
          <button onClick={onConfirm} disabled={busy} data-testid="edit-price-confirm-btn" className="btn-primary flex-1 py-2 text-sm disabled:opacity-50">
            {action === 'top_up' ? `SAVE & PAY ${inr(quote.top_up_amount)}` : 'SAVE CHANGES'}
          </button>
        </div>
      </div>
    </div>
  );
};
